<template>
  <div class="container">
    <nyTit1 pathUrl="/sanchan11" />
    <div class="content">
      <div class="First">
        <div class="title">
          <span class="txt1">品牌一产</span
          ><span class="txt2">Brand first production</span>
        </div>
        <div class="First_content">
          <!--第一部分上开始-->
          <div class="First_top">
            <div class="xiao_biao_ti">粮食安全根基稳固</div>
            <div class="nie_rong"><leftPie /></div>
            <div class="dow_nie_rong">
              <img src="../assets/img/pingpai/v1/ls.png" />
              <span>2024年粮食总产21.71亿斤，实现“二十一连丰”</span>
            </div>
          </div>
          <!--第一部分中间开始-->
          <div class="First_middle">
            <div class="xiao_biao_ti">畜牧产业优质发展</div>
            <div class="tu_biao_list">
              <div
                class="biao_list_nr"
                v-for="(item, index) in left_data"
                :key="index"
              >
                <img :src="item.header" />
                <span>{{ item.name }}</span>
                <span>{{ item.fensi }}</span>
              </div>
            </div>
          </div>
          <!--第一部分下开始-->
          <div class="First_down">
            <div class="xiao_biao_ti">特色结构不断优化</div>
            <div class="te_se">
              <div
                class="te_se_jie_gou"
                v-for="(item, index) in left_data2"
                :key="index"
              >
                <span class="di1"> {{ item.typ }}</span>
                <span class="di2"> {{ item.name }}</span>
                <span class="di3"> {{ item.fensi }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 左边第2个开始 -->
      <div class="Second margin-left">
        <div class="title">
          <span class="txt1">县有特色品牌</span
          ><span class="txt2">The county has distinctive brands</span>
        </div>
        <div class="margin-left_content">
          <div class="left_content_1">
            <img src="../assets/img/pingpai/v1/jc.png" />
            <p>
              {{ txt1 }}
            </p>
          </div>
          <div class="left_content_2">
            <div
              class="left_content_2_txt"
              v-for="(item, index) in left_data3"
              :key="index"
            >
              <span class="span_1">{{ item.name }}</span>
              <span class="span_2">{{ item.value }}</span>
            </div>
          </div>
          <div class="left_content_3">
            <p>{{ txt2 }}</p>
          </div>
          <div class="left_content_4">
            <div
              class="content_4_txt"
              v-for="(item, index) in left_data4"
              :key="index"
            >
              <img :src="item.header" />
            </div>
          </div>
        </div>
      </div>
      <!-- 左边第2个结束 -->

      <div class="Third margin-left">
        <div class="title">
          <span class="txt1">一乡一业一园区</span
          ><span class="txt2"></span>
        </div>
        <div class="Third_content">
          <div class="Third_content_biaoti">
            全县26个乡镇共有乡村振兴车间286个，带动就业1.2万
          </div>
          <div class="Third_content_1">
            <div
              class="Third_content_1_sp"
              v-for="(item, index) in center_data"
              :key="index"
              @click="videoClick(index, 1,item.type)"
            >
              <img class="Third_content_sp_tup" :src="item.img" />
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>

        <!-- <img src="../assets/img/pingpai/v1/2.jpg" alt="" /> -->
      </div>
      <div class="Fourth margin-left">
        <div class="title">
          <span class="txt1">一村一品一基地</span
          ><span class="txt2"></span>
        </div>
        <div class="Third_content">
          <div class="Third_content_biaoti">
            全县448个村（居）共有种养基地3892个，面积13.1万亩
          </div>
          <div class="Third_content_1">
            <div
              class="Third_content_1_sp"
              v-for="(item, index) in center_datas1"
              :key="index"
              @click="videoClick(index, 2,item.type)"
            >
              <img class="Third_content_sp_tup" :src="item.img" />
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
        <!-- <img src="../assets/img/pingpai/v1/3.jpg" alt="" /> -->
      </div>
      <!-- 弹窗 -->
      <popBg v-if="popShow" :title="type == 1  ? center_data[curVideoIndex].name : center_datas1[curVideoIndex].name"
             :code="type == 1? center_data[curVideoIndex].code : center_datas1[curVideoIndex].code"
             :popShow="popShow" @hiddlen="popHiddlen">
        <div style=" width: 100%;height: 100%" v-if="videotype===1">
          <vue3VideoPlay id="video" width="100%" height="100%" title=""
           :src=" type == 1 ? center_data[curVideoIndex].options.src : center_datas1[curVideoIndex].options.src"
           :type="type == 1 ? center_data[curVideoIndex].options.type : center_datas1[curVideoIndex].options.type " :autoPlay="true" />
        </div>
        <div style=" width: 100%;height: 100%" v-else>
          <iframe :src="type == 1 ? center_data[curVideoIndex].options.src+AccessToken : center_datas1[curVideoIndex].options.src+AccessToken"
            width="100%" height="100%" id="ysOpenDevice" allowfullscreen>
          </iframe>

        </div>
      </popBg>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import axios from "axios";
import * as THREE from "three";

import {
  reactive,
  toRefs,
  ref,
  onMounted,
  onUnmounted,
  onBeforeUnmount,
  getCurrentInstance,
  inject
} from "vue";
import leftPie from "@/components/pingpai/left_pie";
import leftbar from "@/components/pingpai/left_bar";
import { useRouter } from "vue-router";
import popBg from "../components/popBg.vue";
import nyTit1 from "@/components/nyTit1.vue";
export default {
  name: "Home",
  setup() {
    const router = useRouter();
    const AccessToken = inject('AccessToken')
    const state = reactive({
      url: "https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img",
      left_data: [
        {
          id: 1,
          name: "规模养殖场",
          fensi: "320个",
          header: require("../assets/img/pingpai/v1/gm1.png"),
        },
        {
          id: 2,
          name: "省级畜牧龙头企业",
          fensi: "3家",
          header: require("../assets/img/pingpai/v1/sj1.png"),
        },
        {
          id: 3,
          name: "市级龙头企业",
          fensi: "9家",
          header: require("../assets/img/pingpai/v1/lt1.png"),
        },
        {
          id: 4,
          name: "省级生态示范场",
          fensi: "2个",
          header: require("../assets/img/pingpai/v1/st1.png"),
        },
        {
          id: 4,
          name: "市级美丽牧场",
          fensi: "5个",
          header: require("../assets/img/pingpai/v1/mc1.png"),
        },
      ],
      left_data2: [
        {
          typ: "小麦",
          name: "面积:152万亩",
          fensi: "产量:82.7万吨",
        },
        {
          typ: "玉米",
          name: "面积:90.59万亩",
          fensi: "产量:58.54万吨",
        },
        {
          typ: "花生",
          name: "面积:40.2万亩",
          fensi: "产量:12.18万吨",
        },
        {
          typ: "大豆",
          name: "面积:1.98万亩",
          fensi: "产量：1.5万吨",
        },
        {
          typ: "芝麻",
          name: "面积:15.5万亩",
          fensi: "产量:1.41万吨",
        },
        {
          typ: "红薯",
          name: "面积:3.5万亩",
          fensi: "产量:1.41万吨",
        },
        {
          typ: "蔬菜",
          name: "面积:15.5万亩",
          fensi: "产量:38万吨",
        },
        {
          typ: "西甜瓜",
          name: "面积:0.9万亩",
          fensi: "产量:3万吨",
        },
        {
          typ: "食用菌",
          name: "面积:1460万棒",
          fensi: "产量:1.2万吨",
        },
      ],
      left_data3: [
        {
          name: "家庭农场",
          value: "1986家",
        },
        {
          name: "农民合作社",
          value: "6494家",
        },
        {
          name: "国家级示范社",
          value: "5家",
        },
        {
          name: "省级示范社",
          value: "8家",
        },
        {
          name: "省级家庭农场",
          value: "6家",
        },
        {
          name: "省级农业产业化集群",
          value: "2个",
        },
        {
          name: "省级农业产业化龙头企业",
          value: "7家",
        },
        {
          name: "市级农业产业化龙头企业",
          value: "52家",
        },
      ],
      left_data4: [
        {
          name: "姜",

          header: require("../assets/img/pingpai/v1/hj1.jpg"),
        },
        {
          name: "红薯",

          header: require("../assets/img/pingpai/v1/hs.png"),
        },
        {
          name: "萝卜",

          header: require("../assets/img/pingpai/v1/lb.png"),
        },

      ],
      center_data: [
        {
          name: "爱绒艺玩具厂",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放

          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_1_18/1-9/image/1-1.gif",
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ8538624/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"AZ8538624"
        },
        {
          name: "古醇香油",
          type:2,
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/bazi/bazi/34h.gif",
          options: {
            src: "https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/FB2502062/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"FB2502062"
        },
        {
          name: "大叔炒栗",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/bazi/bazi/32h.gif",
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/FA2455296/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"FA2455296"
        },
        {
          name: "诱足鞋面加工厂",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/sxt/10.png",
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ8538799/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"AZ8538799"
        },
        {
          name: "邵杨箱包厂",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_1_18/1-9/image/1-5.gif",
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AY8102775/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"AY8102775"
        },
        {
          name: "祥欣鞋业",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/sxt/21.png",
          // options: {
          //   src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_1_18/1-9/6.mp4", //视频源
          //   type: "video/mp4", //视频类型
          // },
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/FA2455035/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"FA2455035"
        },
        {
          name: "五龙冠鑫体育用品厂",
          type:1,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_1_18/1-9/image/1-7.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_1_18/1-9/7.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "豫顺箱包厂",
          type:1,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_1_18/1-9/image/1-8.gif",
          options: {
            src: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_1_18/1-9/8.mp4", //视频源
            type: "video/mp4", //视频类型
          },
        },
        {
          name: "香雪食品厂",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_1_18/1-9/image/1-9.gif",
          // options: {
          //   src: "https://open.ys7.com/v3/openlive/AY7450743_1_2.m3u8?expire=1741945038&id=690252577509486592&t=e2c894020feaca6e3457601675f5172e1e0e9423f0bdad56898f4a74b8326d62&ev=100", //视频源
          //   type: "m3u8", //视频类型
          // },
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AY7450743/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"AY7450743"
        },
      ],

      center_datas1: [
        {
          name: "鲜切花种植基地",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放

          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/bazi/bazi/43h.gif",
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/FC4283860/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"FC4283860"
        },
        {
          name: "葡萄种植基地",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放
          // img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_1_18/10-18/image/1-16.gif",
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/sxt/11.png",
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ9200473/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"AZ9200473"
        },
       
        {
          name: "小岳寺猕猴桃种植基地",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放
          // img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_1_18/10-18/image/1-13.gif",
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/sxt/13.png",
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ8538594/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"AZ8538594"
        },
        {
          name: "番茄种植基地",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/bazi/bazi/39h.gif",
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/FB2502104/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"FB2502104"
        },
        {
          name: "甜瓜种植基地",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放
          // img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_1_18/10-18/image/1-14.gif",
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/sxt/31.png",
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/FA2454922/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"FA2454922"
        },

         {
          name: "湖羊养殖基地",
           type:2,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_1_18/10-18/image/1-15.gif",
           options: {
             src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AY8102714/1.live&autoplay=1&accessToken=", //视频源
             type: "m3u8", //视频类型
           },
           code:"AY8102714"
        },
        {
          name: "云鹤鸽子养殖基地",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放
          img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_1_18/10-18/image/1-18.gif",
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/AZ8538549/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"AZ8538549"
        },
        {
          name: "上蔡县得全养殖有限公司",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放
          // img: "https://lcamapp.oss-accelerate.aliyuncs.com/video/video/shangcaishiping/ronghechanye_1_18/10-18/image/1-18.gif",
          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/sxt/29.png",
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/FA2455066/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"FA2455066"
        },
        {
          name: "生态鸡鸭场",
          type:2,//1是使用VideoPlay播放2是直接嵌套播放

          img: "https://lcamapp.oss-cn-beijing.aliyuncs.com/video/video/bazi/bazi/41h.gif",
          options: {
            src: " https://open.ys7.com/ezopen/h5/iframe?url=ezopen://open.ys7.com/FB2502253/1.live&autoplay=1&accessToken=", //视频源
            type: "m3u8", //视频类型
          },
          code:"FB2502253"
        },
      ],
      type: 1,
      txt1: "坚持协调发展、高质高效、联农带农、利益共享的发展思路，把发展壮大龙头企业规模放在首位，一手抓新建，一手抓改造，不断扩大增量，激活存量，增加总量，不断培育壮大各类新型农业经营主体。",
      txt2: "农业品质品牌明显提升，被农业农村部认定农业企业品牌1家、区域公用品牌1家、产品品牌8家，名特优新农产品10个，全县认证“三品一标”农产品75家142个，其中“邵店黄姜”“崇礼红薯”“无量寺高青萝卜” 被认定为国家地理标志农产品。",
      popShow: false,
      curVideoIndex: 0,
      isShow: false,
      startVal: 0, //数字结束
      videotype:1,
      AccessToken:""
    });
    onMounted(() => {
      init();
      animate();
      state.AccessToken = localStorage.getItem('AccessToken')
    });
    onUnmounted(() => {
      // 清理资源
      // renderer.dispose();
    });
    // 弹出视频
    function videoClick(index1, type,types) {
      console.log(index1);
      state.popShow = true;
      state.curVideoIndex = index1;
      state.type = type;
      state.videotype = types;
    }
    function videoClicks(index1) {
      console.log(index1);
      state.popShow = true;
      state.curVideoIndex = index1;
    }

    // 关闭弹出
    function popHiddlen() {
      state.popShow = false;
    }

    onBeforeUnmount(() => {
      // clearInterval(timer.value);
    });
    // 返回上一页
    function clickReturn() {
      console.log("上一页");
      router.go(-1);
    }
    function close() {
      state.isShow = !state.isShow;
    }
    // 旋转
    function init() {
      // 初始化渲染器
    }
    function animate() {}
    return {
      ...toRefs(state),
      close,
      clickReturn,
      videoClick,
      videoClicks,
      popHiddlen,
    };
  },
  components: {
    nyTit1,
    leftPie,
    leftbar,
    popBg,
  },
};
</script>

<style lang="less" scoped>
a {
  display: block;
  width: 100%;
  height: 100%;
}
.container {
  width: 100%;
  height: 100%;
  background: url("https://lcamapp.oss-cn-beijing.aliyuncs.com/uploads/img/img/xaiofei/data1/bj.jpg")
    no-repeat top center;
  background-size: 100% 100% !important;
  color: #fff;
  position: relative;

  // 标题
  //4个区域内容的标题
  .First .title {
    background: url("../assets/img/pingpai/v1/1bt.png") no-repeat;
  }
  .title {
    width: 100%;
    height: 60px;
    padding-left: 50px;
    box-sizing: border-box;
    line-height: 60px;
    color: #fff;
    background: url("../assets/img/pingpai/v1/2bt.png") no-repeat;
    display: flex;
    span {
      display: block;
    }
    .txt1 {
      font-size: 30px;
      background: linear-gradient(to bottom, #fff 25%, #abdfff 100%);
      background-clip: text;
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      font-style: italic;
      font-weight: bold;
      padding: 0 10px;
    }
    .txt2 {
      color: #0287ba;
      margin-left: 20px;
      font-size: 22px;
      font-family: Arial, Helvetica, sans-serif;
    }
  }
  //公共标题区域
  .xiao_biao_ti {
    width: 80%;
    height: 55px;
    background: #072d50;
    font-size: 28px;
    text-align: left;
    display: flex;
    //justify-content: center;
    align-items: center;
    text-indent: 1em;
    margin-top: 15px;
  }
  // 内容区域
  .content {
    position: absolute;
    top: 220px;
    left: 0;
    width: 100%;

    height: calc(100% - 210px);
    display: flex;
    position: relative;
    padding: 20px 80px 48px;
    box-sizing: border-box;
    .margin-left {
      margin-left: 100px;
      // border: #fff 1px solid;
    }
    .First {
      flex-basis: 13%;
      height: 100%;
      // border: #fff 1px solid;
      margin-left: 25px;
      display: flex;
      flex-direction: column;

      .First_content {
        flex: 1;
        display: flex;
        flex-direction: column;
      }
      .First_top {
        display: flex;
        flex-direction: column;

        width: 100%;
        height: 350px;
        .nie_rong {
          flex: 1;
        }
        .dow_nie_rong {
          width: 100%;
          height: 60px;
          display: flex;
          img {
            display: flex;
            width: 56px;
            height: 52px;
            justify-content: center;
            align-items: center;
            margin-left: 85px;
          }
          span {
            display: flex;
            // justify-content: center;
            align-items: center;
            font-size: 28px;
            background: linear-gradient(to bottom, #fff 25%, #abdfff 100%);
            background-clip: text;
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
            font-style: italic;
            font-weight: bold;
            flex: 1;
            text-indent: 1em;
          }
        }
      }
      .First_middle {
        width: 100%;
        flex: 1;
        .tu_biao_list {
          width: 100%;
          height: 100%;
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          .biao_list_nr {
            height: 35%;
            width: 33%;
            // border: 1px solid #fff;
            flex-shrink: 0;
            // float: left;
            position: relative;

            img {
              width: 85px;
              height: 85px;
              display: flex;
              align-items: center;
              position: absolute;
              left: 0;
              top: 50px;
            }
            span {
              font-size: 24px;
              color: #fff;
              display: flex;
              align-items: center;
              position: relative;
              line-height: 40px;
              top: 60px;
              left: 80px;
            }
          }

          .biao_list_nr:last-child {
            img {
              left: 0;
              top: 30px;
            }
            span {
              top: 30px;
              left: 80px;
            }
          }

          .biao_list_nr:nth-last-child(2) {
            img {
              left: 0;
              top: 30px;
            }
            span {
              top: 30px;
              left: 80px;
            }
          }
        }
      }
      .First_down {
        width: 100%;
        // flex: 1;
        height: 550px;
        display: flex;
        flex-direction: column;
        .te_se {
          width: 100%;
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          .te_se_jie_gou {
            width: 33.33%;
            height: 33.33%;
            // border: #fff 1px solid;
            background: url("../assets/img/pingpai/v1/xm.png") no-repeat 0% 50%;
            background-size: 37% 55%;

            position: relative;
            .di1 {
              font-size: 24px;
              position: absolute;
              left: 6%;
              top: 39%;
              background: linear-gradient(to bottom, #fff 25%, #abdfff 100%);
              background-clip: text;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              // font-style: italic;
              font-weight: bold;
              padding: 0 9px;
            }
            .di2 {
              font-size: 28px;
              padding: 0 3px;

              position: absolute;
              top: 12%;
              left: 26%;
              background: linear-gradient(to bottom, #fff 25%, #abdfff 100%);
              background-clip: text;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              // font-style: italic;
              font-weight: bold;
            }
            .di3 {
              font-size: 28px;

              position: absolute;
              top: 58%;
              left: 26%;
              background: linear-gradient(to bottom, #fff 25%, #abdfff 100%);
              background-clip: text;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              // font-style: italic;
              font-weight: bold;
              padding: 0 3px;
            }
          }
        }
      }
    }
    .Second {
      flex-basis: 23%;
      height: 100%;
      margin-left: 100px;
      position: relative;
      display: flex;
      flex-direction: column;
      .margin-left_content {
        width: 100%;
        flex: 1;
        display: flex;
        flex-direction: column;
        .left_content_1 {
          width: 100%;
          flex: 1;
          position: relative;
          img {
            width: 64px;
            height: 64px;
            top: 10px;
            left: 20px;
            position: absolute;
          }
          p {
            font-size: 38px;
            color: #fff;
            position: absolute;
            left: 80px;
            top: 10px;
            text-align: left;
            line-height: 65px;
            // text-indent: 2em;
          }
        }
        .left_content_2 {
          width: 100%;
          flex: 1;
          display: flex;
          flex-wrap: wrap;
          .left_content_2_txt {
            width: 20%;
            height: 110px;
            // border: #0287ba 1px solid;
            margin: 10px 2.5%;
            background: url("../assets/img/pingpai/v1/xkk1.png") no-repeat top
              center;
            background-size: 100% 100%;
            .span_1 {
              width: 100%;
              height: 50px;
              font-size: 25px;
              color: #fff;
              text-align: center;
              display: block;
              line-height: 50px;
              margin-top: 10px;
            }
            .span_2 {
              width: 100%;
              height: 50px;
              font-size: 30px;
              color: #fff;
              text-align: center;
              display: block;
              background: linear-gradient(to bottom, #fff 25%, #abdfff 100%);
              background-clip: text;
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
              font-style: italic;
              font-weight: bold;
              line-height: 50px;
            }
          }
        }
        .left_content_3 {
          width: 100%;
          flex: 1;
          position: relative;
          p {
            font-size: 38px;
            color: #fff;
            position: absolute;
            left: 80px;
            top: 10px;
            text-align: left;
            line-height: 65px;
            // text-indent: 2em;
          }
        }
        .left_content_4 {
          width: 100%;
          height: 451px;

          display: flex;
          .content_4_txt {
            margin: 0 25px;
            flex: 1;
            height: 451px;

            background: url("../assets/img/pingpai/v1/tpk.png") no-repeat top
              center;
            background-size: 100% 100%;
            img {
              width: 400px;
              height: 400px;
              margin: 26px 26px;
            }
          }
        }
      }
      // img {
      //   width: 100%;
      //   height: calc(100% - 60px);
      //   position: absolute;
      //   left: -1px;
      //   top: 52px;
      // }
    }
    //左边内容的公共样式
    .Third_content {
      width: 100%;
      flex: 1;
      display: flex;
      flex-direction: column;
      .Third_content_biaoti {
        width: 100%;
        height: 80px;
        background: url("../assets/img/pingpai/v1/jc.png") no-repeat 2px 5px;
        // border: 1px solid #fff;
        font-size: 38px;
        color: #fff;
        text-indent: 2em;
        text-align: left;
        display: flex;
        // justify-content: center;
        align-items: center;
      }
      .Third_content_1 {
        width: 100%;
        flex: 1;
        display: flex;
        flex-wrap: wrap;

        .Third_content_1_sp {
          width: 550px;
          height: 367px;

          flex: 1;
          margin: 25px 25px;
          background: url("../assets/img/pingpai/v1/spk.png") no-repeat top
            center;
          background-size: 100% 100%;
          position: relative;

          .Third_content_sp_tup {
            width: 530px;
            height: 340px;
            margin: 15px 5px;
            padding: 7px 5px;
          }
          span {
            width: 100%;
            font-size: 42px;
            height: 60px;
            // background: linear-gradient(to bottom, #fff 25%, #abdfff 100%);
            // background-clip: text;
            // -webkit-background-clip: text;
            // -webkit-text-fill-color: transparent;
            // font-style: italic;
            // font-weight: bold;
            padding: 0 10px;
            line-height: 60px;
            // text-indent: 1em;
            position: absolute;
            color: #fff;
            left: 0%;
            // top: 45%;
            bottom: 2%;
            z-index: 2;
            background: rgba(20, 54, 102, 0.6);
          }
        }
      }
    }

    .Third {
      flex-basis: 29%;
      height: 100%;
      position: relative;
      display: flex;
      flex-direction: column;
    }
    .Fourth {
      flex-basis: 29%;
      height: 100%;
      position: relative;
      display: flex;
      flex-direction: column;
    }
  }
}
</style>
